import { useCallback } from 'react';

import qs from 'qs';

import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { useSessionUuidAsync } from 'src/app/shared/hooks/session';
import type { ShareChannel } from 'src/app/shared/hooks/share';
import { isLoaded } from 'src/app/shared/utils/async';

export function useGetUrl(slug: string, currentUserId: string | undefined): (channel: ShareChannel) => string {
	const { resolveUrl } = useUtilityContext();
	const sessionState = useSessionUuidAsync();
	const sessionUuid = isLoaded(sessionState) ? sessionState.value : undefined;

	return useCallback(
		(_channel: ShareChannel) => {
			const utmParams = qs.stringify(
				{
					utm_source: 'share_petition',
					utm_medium: 'mobileNativeShare',
					utm_campaign: 'share_petition',
					recruited_by_id: sessionUuid,
					recruiter: currentUserId,
				},
				{ encodeValuesOnly: true },
			);

			return resolveUrl(`/p/${slug}?${utmParams}`);
		},
		[currentUserId, slug, resolveUrl, sessionUuid],
	);
}
